<template>
  <v-card elevation="1">
    <v-card-text class="d-flex justify-center">
      <div class="d-flex text-center align-center flex-column w-50 gap-2">
        <SearchIcon />
        <h4>Інформацію не знайдено</h4>
        <span style="color: #7e92a2">
          Це може означати, що боржник не має активних зобов’язань перед банками
          або інформація наразі недоступна.
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import SearchIcon from '@/assets/images/SearchIcon.vue'
</script>

<style scoped lang="scss"></style>
